// Beta-shaped segments. condition is the nested AND/OR tree the real API uses.
const rule = (attribute_id, operator, value) => ({ type: 'attribute', attribute_id, operator, value });
const group = (rules, op = 'AND') => ({ criteria_operator: op, criteria_id_1: rules });

export const segments = [
  { segment_id: 2000, name: 'Pet DNA Kit owners', condition_operator: 'AND',
    condition: [ { criteria_operator: 'AND', criteria_id_1: [ { type: 'product', operator: 'INCLUSIVE', value: [700] } ] } ] },
  { segment_id: 2001, name: 'Allergies = Yes', condition_operator: 'AND',
    condition: [ group([ rule(501, 'EQUAL', ['Yes']) ]) ] },
  { segment_id: 2002, name: 'Allergies = No', condition_operator: 'AND',
    condition: [ group([ rule(501, 'EQUAL', ['No']) ]) ] },
  { segment_id: 2003, name: 'Diet = Premium', condition_operator: 'AND',
    condition: [ group([ rule(502, 'EQUAL', ['Premium']) ]) ] },
  { segment_id: 2004, name: 'Severe = Yes', condition_operator: 'AND',
    condition: [ group([ rule(503, 'EQUAL', ['Yes']) ]) ] },
  // multi-trigger: references attribute 501 (from touchpoint 101) AND 502 (from touchpoint 102)
  { segment_id: 2005, name: 'Allergies = Yes AND Diet = Premium', condition_operator: 'AND',
    condition: [ group([ rule(501, 'EQUAL', ['Yes']), rule(502, 'EQUAL', ['Premium']) ]) ] },
];

export const segmentById = (id) => segments.find((s) => s.segment_id === id) || null;

// NOTE: the segment readers (segmentAttributeRefs / resolveSegmentRefs) live in
// src/pages/journeys/segment/segmentRead.js, and the humanizer in segment/segmentHumanize.js —
// the shared understanding of a condition tree used by the card + drawer. This file holds fixture DATA only.
